import { render, staticRenderFns } from "./task.vue?vue&type=template&id=57d7c062&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=57d7c062&prod&land=scss&lang=css"
import style1 from "./task.vue?vue&type=style&index=1&id=57d7c062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7c062",
  null
  
)

export default component.exports